// extracted by mini-css-extract-plugin
export default {"Modal":"RemoveCustomLawModal_Modal__5FoTE"};